import { useContext } from 'react'
import {
  chain,
  Description,
  Link,
  PropertyWidget,
  useDateTimeFormat,
  useMoneyFormat,
  VStack,
} from '@revolut-internal/ui-kit'

import { BACKOFFICE_URL } from 'lib/auth'

import { PromptTransactionsContext } from '../PromptTransactionsContext'

export const Transactions = () => {
  const moneyFormat = useMoneyFormat({ type: 'money-fractional' })
  const dateTimeFormat = useDateTimeFormat({
    style: 'precise',
  })

  const transactionsData = useContext(PromptTransactionsContext)

  if (!transactionsData || !transactionsData.transactions.length) {
    return null
  }

  const { transactions, clientId } = transactionsData

  return (
    <VStack>
      <Description>{chain('Transactions', transactions.length)}</Description>
      <VStack space="s-8">
        {transactions.map(
          ({
            id,
            type,
            state,
            description,
            createdDate,
            completedDate,
            transactionAmount,
          }) => (
            <PropertyWidget key={id}>
              <PropertyWidget.Details>
                {chain(
                  `Created: ${dateTimeFormat(new Date(createdDate))}`,
                  `Completed: ${dateTimeFormat(new Date(completedDate))}`,
                )}
              </PropertyWidget.Details>

              <PropertyWidget.Title>
                <Link
                  href={`${BACKOFFICE_URL}/users/${clientId}/transactions/${id}`}
                  target="_blank"
                  title="Transaction details"
                >
                  {chain(
                    type,
                    state,
                    transactionAmount ? moneyFormat(transactionAmount) : null,
                  )}
                </Link>
              </PropertyWidget.Title>
              {description && (
                <PropertyWidget.Description>{description}</PropertyWidget.Description>
              )}
            </PropertyWidget>
          ),
        )}
      </VStack>
    </VStack>
  )
}
